import React from 'react';
import { useTranslation } from 'react-i18next';

import { OpModal } from 'new-components/DLS/OpModal/OpModal';
import { OpText } from 'new-components/DLS/OpText/OpText';
import { OpButton } from 'new-components/DLS/OpButton/OpButton';
import { OpLink } from 'new-components/DLS/OpLink/OpLink';

interface MigratedInfoModalProps {
  isVideoPartner: boolean;
  open: boolean;
  onCancel: () => void;
}

/**
 * @component
 * @description Modal that displays migration information for users coming from DMP.
 * This is a controlled component - visibility is managed by the parent.
 */
export const MigratedInfoModal = ({
  open,
  onCancel,
  isVideoPartner,
}: MigratedInfoModalProps) => {
  const { t } = useTranslation();
  const leadingWord = isVideoPartner ? 'DMP' : 'Partner';

  return (
    <OpModal
      className="migrated-info-modal"
      open={open}
      onCancel={onCancel}
      title={t('Welcome to the Alta Partner App')}
      footer={
        <OpButton type="primary" onClick={onCancel}>
          {t('Continue')}
        </OpButton>
      }
      testId="migrated-info-modal"
    >
      <OpText>
        {t(
          `Your ${leadingWord} account has been successfully migrated. Continue using your existing username and password.`,
        )}
      </OpText>
      <br />
      <OpText>
        {t(`Update your ${leadingWord} bookmark to: `)}
        <OpLink route="/">{window.location.href}</OpLink>
      </OpText>

      <br />

      <OpText>
        {t(
          'To learn more about the Alta Partner App, please check out the following documentation',
        )}
        {` `}
        <a
          className="migrated-info-modal__docs-link"
          href="https://docs.avigilon.com/bundle/alta-partner-app/page/alta-partner/app-overview.htm"
          target="_blank"
          rel="noreferrer noopener"
        >
          {t('here')}
        </a>
      </OpText>
    </OpModal>
  );
};
